interface BrandLogoProps {
  className?: string;
}

export function BrandLogo({ className = "w-8 h-8" }: BrandLogoProps) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Malhotra's Financial Vault Logo"
      role="img"
    >
      <rect x="8" y="8" width="84" height="84" rx="16" fill="#102D4C" />
      <path
        d="M25 70 V35 L40 50 L55 35 V70"
        stroke="#B98937"
        strokeWidth="5"
        fill="none"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M55 35 H75 M55 52 H68"
        stroke="#B98937"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M45 80 L50 86 L65 70"
        stroke="#0F766E"
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}